import React from 'react';
import { useI18n } from '../i18n/I18nContext';

const languages = [
  { code: 'en', label: 'EN' },
  { code: 'fr', label: 'FR' },
  { code: 'ar', label: 'عربي' },
];

export default function LanguageSwitcher() {
  const { lang, setLanguage } = useI18n();

  return (
    <div style={{
      position: 'fixed', top: 12, right: 12, zIndex: 9999,
      display: 'flex', gap: 4, background: 'rgba(0,0,0,0.7)',
      borderRadius: 8, padding: '3px 5px',
    }}>
      {languages.map((l) => (
        <button
          key={l.code}
          onClick={() => setLanguage(l.code)}
          style={{
            border: 'none',
            background: lang === l.code ? '#fff' : 'transparent',
            color: lang === l.code ? '#000' : '#fff',
            fontWeight: lang === l.code ? 700 : 400,
            borderRadius: 6,
            padding: '3px 8px',
            cursor: 'pointer',
            fontSize: 13,
          }}
        >
          {l.label}
        </button>
      ))}
    </div>
  );
}
